module.exports = __webpack_public_path__ + "img/img_insta.269a7b04.png";